import React from "react";

interface SubHeading {
  title: string;
  link: string;
}

interface FooterLinksProps {
  heading: string;
  subHeading: SubHeading[];
}

const FooterLinks: React.FC<FooterLinksProps> = ({ heading, subHeading }) => {
  return (
    <div className="flex px-4 sm:justify-self-end">
      <div className="mb-12 lg:mb-16">
        <h2 className="mb-10 text-lg font-bold text-black dark:text-white">
          {heading}
        </h2>
        <ul>
          {subHeading.map((subHeadingSingle) => (
            <li key={subHeadingSingle.link}>
              <a
                href={subHeadingSingle.link}
                className="mb-3 inline-block text-base text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
              >
                {subHeadingSingle.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FooterLinks;
